





































































import { Component, Vue, Ref } from 'vue-property-decorator';
import { register, getegisterCode } from '@/apis/user';
import { Base64 } from '@/utils/common';
import { isMobile, isPassword } from '@/utils/validate';
import { UserModule } from '@/store/modules/user';
import { Toast } from 'vant';
import protocol from './protocol.vue';
let clearInter: any;
@Component({
	name: 'Login',
	components: {
		protocol,
	},
})
export default class extends Vue {
	@Ref() private protocol!: protocol;
	private form = { mobilePhone: '', verificationCode: '', newpassword: '', checkedVal: false };
	private totalTime = 120;
	private codeCont = '';
	private currCode = '';
	private codeContent = '获取验证码';
	private isCheckBtnDisable = false;
	private countDown() {
		// 这里解决60秒不见了的问题
		this.isCheckBtnDisable = true;
		this.codeContent = this.totalTime + '重新发送';
		clearInter = window.setInterval(() => {
			this.totalTime--;
			this.codeContent = this.totalTime + '重新发送';
			// 当倒计时小于0时清除定时器
			if (this.totalTime < 0) {
				window.clearInterval(clearInter);
				this.isCheckBtnDisable = false;
				this.codeContent = '获取验证码';
				this.totalTime = 120;
			}
		}, 1000);
	}
	private validatePass(value) {
		if (!value || !isPassword(value)) {
			return false;
		} else {
			if (value.length < 6) {
				return false;
			} else {
				return true;
			}
		}
	}
	private validateUsername(value) {
		if (!value) {
			return false;
		} else if (!isMobile(value)) {
			return false;
		} else {
			return true;
		}
	}
	private openHttp() {
		this.protocol.openPopup();
		// this.$router.push({ path: '/protocol' })
	}
	private login() {
		this.$router.push({ path: '/login' });
	}
	private async getCheckCode() {
		if (this.form.mobilePhone && isMobile(this.form.mobilePhone)) {
			// 如果获取验证码正处于倒计时阶段，不允许提交
			if (this.isCheckBtnDisable) {
				return false;
			}
			const { mobilePhone } = this.form;
			const res = await getegisterCode({ param: mobilePhone });
			if (res.code === 200) {
				Toast.success({
					duration: 2000,
					message: '验证码发送成功！',
				});
				this.countDown();
				// this.currCode = res.data
			}
		} else {
			Toast.fail({
				duration: 2000,
				message: '请输入正确的手机号！',
			});
		}
	}
	private beforeDestroy() {
		clearInterval(clearInter);
	}
	private async onSubmit1() {
		console.log(this.form);
		let { mobilePhone, verificationCode, checkedVal } = this.form;
		if (!this.oem) {
			if (!checkedVal) {
				Toast.fail({
					duration: 2000,
					message: '请阅读使用协议',
				});
				return false;
			}
		}
		let password = Base64.encode(this.form.newpassword);
		let res = await register({ mobilePhone, password, verificationCode });
		if (res.code === 200) {
			this.$router.push({ path: '/login' });
		} else {
			this.form.verificationCode = '';
		}
	}
	get oem() {
		return UserModule.oem;
	}
}
